// Copyright (c) 2018 Deere & Company

export const setAppDynamicsConfig = isProd => {

    window['adrum-start-time'] = new Date().getTime();

    window['adrum-config'] = {};
    window['adrum-config'].appKey = isProd ? 'AD-AAB-AAM-GEE' : 'AD-AAB-AAK-UDH';
    window['adrum-config'].adrumExtUrlHttp = 'http://cdn.appdynamics.com';
    window['adrum-config'].adrumExtUrlHttps = 'https://cdn.appdynamics.com';
    window['adrum-config'].beaconUrlHttp = 'http://col.eum-appdynamics.com';
    window['adrum-config'].beaconUrlHttps = 'https://col.eum-appdynamics.com';
    window['adrum-config'].xd = {enable: false};
    window['adrum-config'].spa = {spa2: true};

};



// WEBPACK FOOTER //
// ./src/shared/services/appdynamics.js